import { InvoiceBillingStage } from '../enums/invoiceBillingStage'
import { InvoiceDisplayedType } from '../enums/invoiceDisplayedType'
import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { isDepositInvoice } from './depositInvoices/isDepositInvoice'
import { isFinalInvoice } from './depositInvoices/isFinalInvoice'
import { isDocumentTypeCreditNote } from './isDocumentTypeCreditNote'

export const getInvoiceDisplayedType = ({
  billingStage,
  documentType,
}: {
  billingStage?: InvoiceBillingStage
  documentType?: InvoiceDocumentType
}): InvoiceDisplayedType => {
  const isCreditNote = isDocumentTypeCreditNote(documentType)
  const isDeposit = isDepositInvoice(billingStage)
  const isFinal = isFinalInvoice(billingStage)

  if (isCreditNote) {
    return InvoiceDisplayedType.CreditNote
  }

  if (isDeposit) {
    return InvoiceDisplayedType.DepositInvoice
  }

  if (isFinal) {
    return InvoiceDisplayedType.FinalInvoice
  }

  return InvoiceDisplayedType.Invoice
}
